import Vue from 'vue';
import Vuex from 'vuex';

import auth from '@/store/auth/index';
import landing from '@/store/landing/index';
import orders from '@/store/orders/index';
import client from '@/store/client/index';
import main from '@/store/main/index';
import autocomplete from '@/store/autocomplete/index';
import services from '@/store/services/index';
import address from '@/store/address/index';
import publicStore from '@/store/public/index';
import chat from '@/store/chat/index';
import imageModal from '@/store/imageModal/index';
import materials from '@/store/materials/index';

import router from '@/router/index';

Vue.use(Vuex);
Vuex.Store.prototype.router = router;

export default new Vuex.Store({
  modules: {
    auth,
    client,
    orders,
    main,
    autocomplete,
    services,
    address,
    public: publicStore,
    chat,
    imageModal,
    materials,
    landing
  }
});